export default __webpack_public_path__ + "static/media/424.d16bd01c.png";